<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="tagView">
                <div class="title_aside"></div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>账号注销</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-row
                :gutter="20"
                type="flex"
                justify="center"
            >
                <el-col :span="18">
                    <div class="Steps">
                        <el-steps :active="active" align-center>
                            <el-step title="同意注销协议"></el-step>
                            <el-step title="账号信息检测"></el-step>
                            <el-step title="申请成功"></el-step>
                        </el-steps>
                    </div>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                type="flex"
                justify="center"
            >
                <el-col :span="16">
                    <div class="pageMain" v-if="active==1">
                        <div class="agreement">
                            <h2>账号注销须知</h2>
                            <h3>请在申请注销前仔细阅读并确认您知晓以下内容：</h3>
                            <p class="bold">一、注销后会发生什么？ </p>
                            <p class="black">1.账号不可登录、服务停止</p>
                            <p>注销成功后，您将无法再登录该账号，本账号下的所有产品和服务将同时停止使用。</p>
                            <p class="black">2.您的个人资料和历史数据将被处理</p>
                            <p>联合信任将对您上传的文件与证据进行物理删除且无法找回，并根据您之前使用产品的情况和相关法律的规定，选择对个人信息、历史数据进行物理删除、匿名化处理或加密处理，包括但不限于:头像、取证申请人信息、交易记录、证据文书及相关证书、时间戳余额等。</p>
                            <p class="black">3.第三方服务一并失效</p>
                            <p>通过本账号授权登录或绑定的第三方服务将无法继续使用，您在各类服务中获得的：充值余额、积分、会员、资格、订单、优惠券、礼品卡、票券及其他卡券权益；均会视为放弃且无法继续使用或恢复。</p>
                            <p class="black">4.账号一旦注销将不可恢复</p>
                            <p>注销后，本账号下的内容和信息数据将无法恢复或转移到其他账号（即使使用相同个人信息或手机号重新注册），您已获得的权益、时间戳赠送次数、参与的活动等视为主动放弃。</p>
                            <p class="black">5.经销商账号可以单独申请注销</p>
                            <p>注销后，您的账户无法登录经销商平台，同时不再进行邀请关系绑定并且终止分润。您的账户在联合信任平台仍为有效状态，不影响您正常登录联合信任平台并使用相关服务。</p>
                            <p class="bold">二、可能影响与法律相关的场景</p>
                            <p class="black">1.与司法、行政机关相关的使用</p>
                            <p>账号注销后，如果您的账号内容仍涉及在办诉讼、仲裁、行政调查等事项，联合信任有权在相关程序中配合司法机关开展相关工作，依法配合提供相关的必要信息。注销账号不影响您在注销前已经产生的权利义务。</p>
                            <p class="black">2.不免除既有责任</p>
                            <p>账号注销仅影响后续服务的使用，不代表您可以否认注销前基于该账号发生的行为，也不免除相关法律责任或义务。</p>
                            <p class="bold">三、申请前请您务必确认</p>
                            <p class="black">1.已妥善备份账号中需要保留的文件、证书、合同、证据及相关数据</p>
                            <p class="black">2.已了解注销后数据无法恢复</p>
                        </div>
                        <div class="checkBox">
                            <el-checkbox v-model="checked"></el-checkbox>
                            <span class="read">我已阅读并同意以上<b>《账号注销须知》</b>，知晓账号及其中数据一旦注销将无法恢复。</span>
                        </div>
                        <div class="btns">
                            <el-button type="primary" @click="$router.replace({path:'/userCenter/security'})">放弃注销</el-button>
                            <el-button type="primary" plain v-if="checked" @click="gostep2">确认注销</el-button>
                        </div>
                        
                    </div>
                    <div class="pageMain" v-if="active==2">
                        <div class="step2">
                            <h3 v-if="result.isOwe || result.isNeedSign">检测到以下问题，暂时无法申请注销，请处理后再申请。</h3>
                            <h3 v-else>正在进行账号信息检测，通过后可进行下一步</h3>
                            <div class="prompt" v-if="hasError">
                                <p>【必须由您亲自处理】</p>
                                <p>请检查未通过项并前往相关页面完成所需操作，否则无法注销：</p>
                            </div>
                            <ul>
                                <template v-if="result.sourceType && result.sourceType.includes(',')">
                                    <li v-for="item in result.sourceTypeName.split(',')" :key="item">
                                        <p><span><i class="el-icon-error"></i></span>{{item}}：有欠费的取证记录</p>
                                    </li>
                                </template>
                                <template v-else-if="result.sourceType">
                                    <li>
                                        <p><span><i class="el-icon-error"></i></span>{{result.sourceTypeName}}：有欠费的取证记录</p>
                                    </li>
                                </template>   
                                <li v-if="!result.isOwe">
                                    <p><span><i class="el-icon-success"></i></span>电子取证、权利卫士等：没有欠费的取证记录</p>
                                </li>
                                <li>
                                    <p v-if="result.isNeedSign"><span><i class="el-icon-error"></i></span>壹签：有待签署的合同</p>
                                    <p v-else><span><i class="el-icon-success"></i></span>壹签：没有待签署的合同</p>
                                </li>
                                <li>
                                    <p v-if="result.hasStudentApprove"><span><i class="el-icon-error"></i></span>学生认证：有学生认证审核未处理</p>
                                    <p v-else><span><i class="el-icon-success"></i></span>没有待处理的学生认证</p>
                                </li>
                                <li>
                                    <p><span><i :class="(result.hasSubmittedConsultOrder || result.hasReceivedConsultOrder)  ? 'el-icon-error':'el-icon-success'"></i></span>找律师服务平台：</p>
                                     <div class="child">
                                        <p v-if="result.hasSubmittedConsultOrder" style="color: #FF1D32;">存在匹配中/已匹配的需求（请取消所有匹配中/已匹配的需求）</p>
                                        <p v-else>无匹配中/已匹配的需求</p>
                                        <template v-if="result.lawyerStatus==1 || result.lawyerStatus==5">
                                            <p v-if="result.hasReceivedConsultOrder" style="color: #FF1D32;">存在待处理/已接受的案源（请放弃所有待处理/已接受的案源）</p>
                                            <p v-else>无已接受的案源</p>
                                        </template>
                                     </div>
                                </li>
                            </ul>

                            <template v-if="result.hasLawyerApply">
                                <div class="prompt" >
                                    <p>【执行注销后，系统将自动处理】</p>
                                    <p>当最终执行注销后，以下事项将自动执行且不可撤销：</p>
                                </div>

                                <div class="platform">
                                    <p>找律师服务平台：</p>
                                    <p>自动拒绝您已提交的律师认证申请</p>
                                </div>
                            </template>

                            <div class="btns">
                                <el-button type="primary" @click="$router.replace({path:'/userCenter/security'})">
                                    {{hasError?'返 回':'放弃注销'}}
                                </el-button>
                                <el-button type="primary" plain v-if="!hasError" @click="annulDia=true">确认注销</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="pageMain" v-if="active==3">
                        <div class="step2 step3">
                            <span class="success_icon"><i class="el-icon-success"></i></span>
                            <h3>您的注销申请已提交，将在3日内完成注销</h3>
                            <p>若在此期间您使用该账号在联合信任任一平台登录，注销流程将终止。</p>
                            <div class="btns">
                                <el-button type="primary" @click="$router.replace({path:'/userCenter/security'})">返  回</el-button>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog
            title="提示"
            :visible.sync="annulDia"
            width="450px"
            top="27vh"
            class="copyDialog copyDialog3"
            center
            :close-on-click-modal="false"
        >
            <div class="hint">
                <p>1.请再次确认注销账号，确认后账号将完成注销，<b>所有业务数据将被删除，数字资产将被清空，且不可恢复！</b>同时绑定的手机号、邮箱将被释放。</p>
                <p>2.您的注销申请提交后，将在3日内完成注销。<b>若在此期间您使用该账号在联合信任任一平台登录，注销流程将终止。</b>点击确定后当前账号将自动退出。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="annul"
                    >确定</el-button
                >
            </span>
        </el-dialog>
    </el-row>

</template>

<script>
export default {
    data() {
        return {
            checked:false,
            active:1,
            result:{
                isNeedSign:false,
                isOwe:false,
                sourceType:'',
            },
            annulDia:false,
            agreeDoc:false,
        };
    },

    components: {},

    computed: {
        hasError(){
            if((this.result.isOwe || this.result.isNeedSign || this.result.hasStudentApprove || this.result.hasSubmittedConsultOrder || this.result.hasReceivedConsultOrder)){
                return true
            }else{
                return false
            }
        }
    },

    created() {
        if(!this.$route.params.pass){
            this.$router.replace({
                path:'/userCenter/security'
            })
        }
    },

    mounted() {},

    methods: {
        gostep2(){
            let that=this;
            this.active=2;
            this.$reqCenter({
                method: "get",
                url: "/userAccount/check",
            }).then((res)=>{
                console.log(res)
                // let {isNeedSign,isOwe,sourceType}=res;
                // if(sourceType){
                //     that.result=res;
                //     that.result.sourceType=sourceType.split(',').map(Number)
                //     console.log(that.result)
                // }else{
                //     that.result=res;
                // }
                that.result=res;
            }).catch((err)=>{
                that.$msg(err.message);
            })
        },
        annul(){
            let that=this;
            this.$reqCenter({
                method: "post",
                url: "/createDeletedRecord",
            }).then((res)=>{
                console.log(res)
                that.active=3;
                that.annulDia=false;
                window.location.href = "/api/logout";
            }).catch((err)=>{
                that.$msg(err.message);
                that.annulDia=false;
            })
        }
    },
};
</script>
<style lang='less' scoped>
.Steps{
    margin-top:20px;
    /deep/ .el-step{
        .el-step__head{
            color:#fff
        }
        .el-step__head.is-process{
            color:#fff;
        }
        .el-step__icon-inner{
            color:#fff;
        }
        .is-finish .el-step__icon{
            background:#409EFF;
        }
        .el-step__head.is-process{
            color: #c0c4cc;
            border-color: #c0c4cc;
        }
        .el-step__title{
            font-size: 14px;
            color: #999999;
        }
        .el-step__title.is-finish{
            color:#409EFF;
        }
        .el-step__title.is-process{
            font-weight: 400;
        }
        .el-step__icon{
            width: 30px;
            height: 30px;
            background:#B4B4B4;
        }
        .el-step__line{
            top:14px;
        }
    }
}
.pageMain{
    margin-top: 30px;
    .agreement{
        margin:0 auto;
        color: #000;
        font-size: 14px;
        background:#FFF5E9;
        border-radius: 5px;
        padding:20px 36px 36px;
        h2{
            font-size: 16px;
            font-weight: 700;
            text-align: center;
            margin-bottom: 12px;
        }
        h3{
            font-size: 14px;
            font-weight: 700;
        }
        p{
            margin-top: 10px;
            color: #666;
            &.bold{
                font-weight: bold;
                color: #000;
            }
            &.black{
                color: #000;
            }
        }
    }
    .checkBox{
        font-size: 14px;
        margin-top: 20px;
        color: #666666;
        .read{
            margin-left: 10px;
        }
    }
    .btns{
        text-align: center;
        margin-top: 52px;
        .el-button{
            margin:0 50px;
            padding: 14px 25px;
        }
    }
    .step2{
        h3{
            text-align: center;
            font-size: 16px;
            font-weight: 700;
        }
        .prompt{
            width: 312px;
            margin:0 auto;
            padding-top: 40px;
            p{
                white-space: nowrap;
                font-size: 14px;
                &:nth-child(1){
                    color: #000;
                    font-weight: bold;
                }
                &:nth-child(2){
                    color: #6D7278;
                }
            }
        }
        ul{
            width: 312px;
            margin:0 auto;
            padding-top: 32px;
            li{
                font-size: 14px;
                color:#333;
                margin-bottom: 22px;
                p{
                    display: flex;
                    align-items: center;
                    white-space: nowrap;
                }
                span{
                    font-size: 20px;
                    margin-right: 10px;
                    display: block;
                    i{
                        display: block;
                    }
                    .el-icon-error{
                        color:#D81E06
                    }
                    .el-icon-success{
                        color:#52C41A
                    }
                }
                .child{
                    padding-left: 28px;
                    padding-top: 3px;
                    p{
                        margin-top: 5px;
                    }
                }
                
            }
        }
        .platform{
            width: 312px;
            margin: 0 auto;
            margin-top: 22px;
            p{
                font-size: 14px;
                white-space: nowrap;
                color: #000;
                &:last-child{
                    margin-top: 7px;
                }
            }
        }
    }
    .step3{
        color: #333;
        font-size: 14px;
        text-align: center;
        p{
            margin-top:30px;
        }
        .success_icon{
            display: block;
            margin-bottom: 30px;
            i{
                font-size: 45px;
                color:#52C41A
            }
        }
    }
}
.copyDialog{
    /deep/ .el-dialog__header{
        padding:10px 20px 10px;
        .el-dialog__headerbtn{
            top:10px;
        }
    }
    /deep/ .el-dialog__footer{
        padding-bottom: 30px;
    }
    .hint {
        p{
            line-height: 25px;
            margin-top:15px;
        }
        b{
            color:#D81E06;
        }
    }
}
/deep/ .agreeDoc{
    .el-dialog{
        border-radius: 4px;
    }
    .el-dialog__header {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        padding: 10px;
        padding-bottom: 10px;
        background: #108ee9;
    }
     .el-dialog__title{
        color: #fff;
    }
    .el-dialog__headerbtn {
        top: 10px;
        font-size: 20px;
    }
    .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
    }
}
</style>